export interface LocalizerState {
    data: Record<string, any>;
}

export const initialLocalizerState = { data: null };
